/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import HealthEntrySummary from '../HealthEntrySummary';
import HealthEntryTitle from './HealthEntryTitle';

import List, { ListItem } from '../List';
import { TextLink } from '../TextLink';
import { Footnote } from '../Text';

const HealthEntrySummaryItem = (props) => {
  const { entry, onClick, languageCode } = props;

  return (
    <ListItem key={entry.id} onClick={onClick ? () => { onClick(entry); } : null}>
      <HealthEntrySummary
        healthEntry={entry}
        languageCode={languageCode}
        areIconsAttachedToRight
      />
    </ListItem>
  );
};

const TogglePast = (props) => {
  const { showHidden, hiddenItemCount, name, titleShowHidden, titleHideRevealed, setShowHidden } = props;

  if (hiddenItemCount === 0) { return null; }

  return (
    <ListItem>
      <div style={{ minHeight: '40px', lineHeight: '30px' }}>
        <TextLink colorClass="font-color-profile" onClick={() => { setShowHidden(!showHidden); }}>
          <Footnote>
            <FormattedMessage id={name} values={{ digit1: hiddenItemCount }}>
              {
                (healthEntryName) => (
                  <FormattedMessage
                    id={showHidden ? titleShowHidden : titleHideRevealed}
                    values={{ string1: healthEntryName.toLowerCase() }}
                  />
                )
              }
            </FormattedMessage>
          </Footnote>
        </TextLink>
      </div>
    </ListItem>
  );
};

interface Props {
  alwaysVisibleContent: any[];
  hideableContent: any[];
  name: string;
  icon: any;
  titleShowHidden?: string;
  titleHideRevealed?: string;
  onClick(he): void;
  languageCode: string;
}

const HealthEntryGroup: React.FC<Props> = (props) => {
  const { alwaysVisibleContent, name, hideableContent, icon, onClick, languageCode, titleShowHidden, titleHideRevealed } = props;

  const [showHidden, setShowHidden] = React.useState(false);

  if (alwaysVisibleContent.length === 0 && hideableContent.length === 0) { return null; }

  return (
    <List hasBorder hasRoundedWrapper paddingSize="default">
      <ListItem className="profile-background-color-5 profile-border-bottom-color-10">
        <HealthEntryTitle
          title={<FormattedMessage id={name} values={{ digit1: 2 }} />}
          icon={icon}
          className="font-color-profile-accent"
        />
      </ListItem>

      {
        alwaysVisibleContent.length > 0 ? (
          alwaysVisibleContent.map((entry) => (
            <HealthEntrySummaryItem
              key={entry.id}
              onClick={onClick ? () => { onClick(entry); } : null}
              entry={entry}
              languageCode={languageCode}
            />
          ))
        ) : null
      }

      <TogglePast
        name={name}
        showHidden={showHidden}
        setShowHidden={setShowHidden}
        hiddenItemCount={hideableContent.length}
        titleShowHidden={titleShowHidden}
        titleHideRevealed={titleHideRevealed}
      />

      {
        showHidden ? (
          hideableContent.map((entry) => (
            <HealthEntrySummaryItem
              key={entry.id}
              onClick={onClick ? () => { onClick(entry); } : null}
              entry={entry}
              languageCode={languageCode}
            />
          ))
        ) : null
      }
    </List>
  );
};

export default HealthEntryGroup;
